import React, { useEffect,useState } from "react"
import { Layout } from "@sudy/sui-react"
import AccountAction from "../accountActivation"
// import ChangePhone from '../changephone/index1'
import Forgetpsw from "../forgetpsw"
import SetOver from "../accountActivation/setOver"
import Appeal from "../forgetpsw/appeal"
import LeftNav from "./left"
import { Menu, Breadcrumb, Select, message } from "antd"
// import { personaldata } from "../../service"


const { Header, Footer, Sider, Content } = Layout
const { Option } = Select;
// const path = process.env.PUBLIC_URL;
// const icon = `${path}/asset/logo.png`
const path = window.imgpath
const content = window.subPath
const footer = window.footer
// const icon = `${path}/asset/logo.png`
const icon =`${path}${content}/_web/_apps/ids/pcs/imgs/logo/avatar.png`

const MainPsw_appeal = () => {
    const [user,setuser] = useState('未登录')
    
    const getHeight = () => {
        const w = document.body.clientWidth;
        if (w < 756) {
            // document.getElementById("logo").src = `${path}/asset/mlogo.png`
            document.getElementById("logo").src = `${path}${content}/_web/_apps/ids/pcs/imgs/logo/mlogo.png`
            document.getElementById("logo").width = 25
            document.getElementById("logo").setAttribute("style","margin-right: 5px;");//一次添加多个
        } else {
            // document.getElementById("logo").src = `${path}/asset/logo.png`
            document.getElementById("logo").src = `${path}${content}/_web/_apps/ids/pcs/imgs/logo/logo.png`
            document.getElementById("logo").width = 219
        }
    }

    window.onresize = function () {
        getHeight()
    }

    useEffect(() => {
        getHeight();
        // personaldata().then((res)=>{
        //     if(!res.resultCode){
        //         console.log(res);
        //     }else{
        //         message.warning(res.errorMsg)
        //     }
        // })
    }, [])

    return (
        <div className="layout-demo" id="components-layout-demo-basic">
            <Layout className="ids">
                <Header>
                    {/* <div className="logo" /> */}
                    <div className="ids-header-container ids-flex justcontent-spb">
                        <img src={icon} alt="" id="logo" />
                        <div className="ids-flex">
                            <div style={{ fontSize: 18 }}>个人中心</div>{" "}
                            <span style={{ paddingLeft: 5, paddingRight: 5 }}>
                                |
                            </span>{" "}
                            <div>找回密码</div>
                        </div>
                        <div className="ids-flex">
                        {/* <span>
                            <img src={`${path}${content}/_web/_apps/ids/pcs/imgs/logo/avatar.png`}></img>
                            <span style={{marginLeft:'15px'}}>{user}</span>
                            </span> */}
                        {/* <Select defaultValue="1" style={{ width: 120 }}>
                            <Option value="1">帮助与反馈</Option>
                        </Select>

                        <div className="ids-padding-lr16">
                            <span className="ids-users">注册</span>
                            <span
                                style={{ paddingLeft: 16 }}
                                className="ids-zx"
                            >
                                登录
                            </span>
                        </div>

                        <div style={{ marginLeft: 40 }}>
                            <span>中文</span> | <span>English</span>
                        </div> */}
                    </div>
                    </div>
                </Header>

                <Layout className="ids-layout">
                    {/* <LeftNav></LeftNav> */}

                    <Content>
                        {/* 激活账号 */}
                        <div>
                            {/* <Forgetpsw /> */}
                            <Appeal />
                            {/* <ChangePhone /> */}
                            {/* <SetOver /> */}
                        </div>
                        {/* <div className="footer">
                        copyright@2016苏迪科技 ICP备案号：苏ICP备15002514号
                        地址：南京市雨花台区软件大道66号华通科技园6楼
                    </div> */}
                    </Content> 
                </Layout>

                <Footer className="ids-footer">
                    <div className="footer">
                        copyright@2016苏迪科技 ICP备案号：苏ICP备15002514号
                    地址：南京市雨花台区软件大道66号华通科技园6楼
                    </div>
                </Footer>
            </Layout>
        </div>
    )
}
export default MainPsw_appeal